/*
 * Final bitmap safeguard for Ehlyianha Faith Gil's A4 cut PDF.
 *
 * html2canvas may omit CSS SVG backgrounds, and its drawing context can retain
 * a transform after rendering. The main exporter already tries to paint the
 * icons, but this serialization-time hook guarantees that both gray scissors
 * are present at the exact horizontal cut line before the JPEG is created.
 *
 * It runs only while the locked Yhana A4 cut wrapper has the export class.
 */

const YHANA_EXPORT_SELECTOR =
  '.pl-wrapper.pl-size-a4.pl-layout-cut:is(.pl-pdf-exporting, .pl-capturing)';

function drawScissors(context, x, y, size) {
  const unit = size / 24;

  context.save();
  context.setTransform(1, 0, 0, 1, 0, 0);
  context.globalAlpha = 0.94;
  context.globalCompositeOperation = 'source-over';
  context.translate(x, y);
  context.scale(unit, unit);
  context.strokeStyle = '#777777';
  context.lineWidth = 2.15;
  context.lineCap = 'round';
  context.lineJoin = 'round';

  context.beginPath();
  context.arc(6, 6, 2.25, 0, Math.PI * 2);
  context.stroke();

  context.beginPath();
  context.arc(6, 18, 2.25, 0, Math.PI * 2);
  context.stroke();

  context.beginPath();
  context.moveTo(20, 4);
  context.lineTo(8.1, 15.2);
  context.stroke();

  context.beginPath();
  context.moveTo(8.1, 8.8);
  context.lineTo(20, 20);
  context.stroke();
  context.restore();
}

function finalizeYhanaCanvas(canvas) {
  if (!(canvas instanceof HTMLCanvasElement)) return;
  if (!(canvas.width > 0) || !(canvas.height > 0)) return;
  if (!document.querySelector(YHANA_EXPORT_SELECTOR)) return;

  const context = canvas.getContext('2d');
  if (!context) return;

  // A 4.6 mm icon on a 210 mm-wide A4 sheet, converted to bitmap pixels.
  const iconSize = Math.max(20, canvas.width * (4.6 / 210));
  const lineY = canvas.height / 2;
  const iconY = lineY - (iconSize / 2);
  const edgeInset = Math.max(0, canvas.width * (0.15 / 210));

  drawScissors(context, edgeInset, iconY, iconSize);
  drawScissors(context, canvas.width - iconSize - edgeInset, iconY, iconSize);
}

if (!window.__ehlyianhaPdfCanvasFinalizerInstalled) {
  window.__ehlyianhaPdfCanvasFinalizerInstalled = true;

  const originalToDataURL = HTMLCanvasElement.prototype.toDataURL;

  HTMLCanvasElement.prototype.toDataURL = function patchedToDataURL(type, quality) {
    const normalizedType = String(type || 'image/png').toLowerCase();

    if (normalizedType === 'image/jpeg' || normalizedType === 'image/jpg') {
      try {
        finalizeYhanaCanvas(this);
      } catch (error) {
        console.warn('Yhana PDF canvas finalizer could not draw scissors:', error);
      }
    }

    return originalToDataURL.call(this, type, quality);
  };
}
